module.exports = __webpack_public_path__ + "img/1.51511315.png";